import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { permanentRedirect } from "@/lib/legacyRedirects";

/** Gammal URL – permanent omdirigering (301). */
export const Route = createFileRoute("/verktyg-tjanster")({
  head: () => seoHead("/verktyg-tjanster"),
  beforeLoad: () => permanentRedirect("/verktyg"),
});
